import React from 'react'
import { useProductState, useLocalLabels } from '@sentecacommerce-theme/lib'
import { ProductPageLabels } from '../../productPage.props'
import { ProductsCarousel } from '../../../ProductsCarousel'

export const RelatedCarousels = ({
  isCategoryCarouselActive,
  isProductsCarouselActive,
}: {
  isCategoryCarouselActive: boolean
  isProductsCarouselActive: boolean
}) => {
  const { metaData } = useProductState()
  const labels = useLocalLabels<ProductPageLabels>()
  return (
    <>
      {metaData?.category?._id && isCategoryCarouselActive && (
        <ProductsCarousel
          isActive={isCategoryCarouselActive}
          heading={`${labels?.moreOf} ${metaData?.category?.name}`}
          viewAllLink={`/${metaData?.category?.slug}/c`}
          query={{
            limit: 10,
            filter: `category;eq;"${metaData?.category?._id}"`,
          }}
        />
      )}
      {metaData?.brand?._id && isProductsCarouselActive && (
        <ProductsCarousel
          isActive={isProductsCarouselActive}
          heading={`${labels?.moreOf} ${metaData?.brand?.name}`}
          viewAllLink={`/${metaData?.brand?.slug}/b`}
          query={{ limit: 10, filter: `brand;eq;"${metaData?.brand?._id}"` }}
        />
      )}
    </>
  )
}
